import { MarketService } from "../../models/market-service";
import { Multimedia } from "src/app/modules/shared/models/multimedia";
import { Schedule } from "../../models/schedule";
import { ServiceFilter } from "../../models/service-filter";
import { createAction, props } from "@ngrx/store";
import { Review } from "../../models/review";
import { ServicePagination } from "@modules/marketplace/models/service-pagination";

export const FetchServices = createAction(
  "[API] FETCH SERVICES",
  props<{
     serviceFilters: ServiceFilter,
     servicePagination: ServicePagination
  }>()
);

export const FetchServicesPaginated = createAction(
  "[API] FETCH SERVICE PAGINATION",
   props<{
      servicePagination: ServicePagination
    }>()
  );

export const FetchServicesFiltered = createAction(
    "[API]ADD SERVICE FILTER",
    props<{
      filters: ServiceFilter
    }>()
);

export const AddServices = createAction(
  "ADD SERVICES",
  props<{ services: MarketService[] }>()
);

export const AddServicePagination = createAction(
  "ADD SERVICE PAGINATION",
  props<{
    servicePagination: ServicePagination
  }>()
);

export const AddServiceFilter = createAction(
  "ADD SERVICE FILTER",
  props<{
    filters: ServiceFilter
  }>()
);

export const RemoveAllServices =  createAction("REMOVE ALL SERVICES");

export const ResetServiceFilter = createAction("RESET SERVICE FILTER");


export const AddService = createAction(
  "ADD SERVICE",
  props<{ service: MarketService }>()
);


export const UpdateService = createAction(
  "UPDATE SERVICE",
  props<{ id: string; change: Partial<MarketService> }>()
);

export const DeleteService = createAction(
  "DELETE SERVICE",
  props<{ id: string }>()
);

export const AddError = createAction(
  "ADD SERVICE ERROR",
  props<{ error: any }>()
);

export const AddServicesTotalCount = createAction(
  "ADD SERVICES TOTAL COUNT",
  props<{ totalCount: number }>()
);

export const AddServiceMedia = createAction(
  "ADD SERVICE MEDIA",
  props<{ serviceId: string; medias: Multimedia[] }>()
);

export const DeleteServiceMedia = createAction(
  "DELETE SERVICE MEDIA",
  props<{ serviceId: string; fileName: string }>()
);

export const AddServiceSchedule = createAction(
  "ADD SERVICE SCHEDULE",
  props<{ serviceId: string; schedules: Schedule[] }>()
);

export const DeleteServiceSchedule = createAction(
  "DELETE SERVICE SCHEDULE",
  props<{ serviceId: string; scheduleId: string }>()
);

export const AddServiceDefaultImage = createAction(
  "ADD SERVICE DEFAULT IMAGE",
  props<{ serviceId: string; media: Multimedia }>()
);

export const RemoveServiceFilter = createAction("REMOVE SERVICE FILTER");

export const SuccessfullyGiveReview = createAction(
  "SUCCESS SERVICE REVIEW",
  props<{ review: Review }>()
);

// Effects actions

export const SaveService = createAction(
  "[Api] SAVE SERVICE",
  props<{ service: MarketService; files?: File[]; schedules?: Schedule[] }>()
);

export const EditService = createAction(
  "[Api] EDIT SERVICE",
  props<{
    id: string;
    change: MarketService;
    files?: File[];
    schedules?: Schedule[];
  }>()
);

export const RemoveService = createAction(
  "[Api] REMOVE SERVICE",
  props<{ id: string }>()
);

export const FetchServicesLegacy = createAction(
  "[Api] FETCH SERVICES LEGACY",
  props<{
    name: string;
    filter: ServiceFilter;
    pageIndex: number;
    pageSize: number;
    sort: string;
    position: string;
  }>()
);

export const FetchMyBookmarkServices = createAction(
  "[Api] FETCH BOOKMARKS SERVICES",
  props<{
    name: string;
    filter: ServiceFilter;
    pageIndex: number;
    pageSize: number;
    sort: string;
    position: string;
  }>()
);

export const FetchServiceById = createAction(
  "[Api] GET SERVICE",
  props<{ id: string }>()
);

export const SaveServiceMedia = createAction(
  "[Api] SAVE SERVICE MEDIA",
  props<{
    serviceId: string;
    files: File[];
  }>()
);

export const RemoveServiceMedia = createAction(
  "[Api] REMOVE SERVICE MEDIA",
  props<{
    serviceId: string;
    fileName: string;
  }>()
);

export const SaveServiceSchedule = createAction(
  "[Api] SAVE SERVICE SCHEDULE",
  props<{
    serviceId: string;
    schedules: Schedule[];
  }>()
);

export const EditServiceSchedule = createAction(
  "[Api] UPDATE SERVICE SCHEDULE",
  props<{
    serviceId: string;
    scheduleId: string;
    change: Partial<Schedule>;
  }>()
);

export const RemoveServiceSchedule = createAction(
  "[Api] REMOVE SERVICE SCHEDULE",
  props<{
    serviceId: string;
    scheduleId: string;
  }>()
);

export const SaveServiceDefaultImage = createAction(
  "[Api] SAVE SERVICE DEFAULT IMAGE",
  props<{
    serviceId: string;
    media: Multimedia;
  }>()
);

export const SaveServiceReview = createAction(
  "[Api] SAVE SERVICE REVIEW",
  props<{
    serviceId: string;
    review: Review;
  }>()
);

export const PublishService = createAction(
  "[Api] PUBLISH SERVICE",
  props<{
    serviceId: string;
    isPublished: boolean;
  }>()
);
